/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IIeOnlyMessageProps } from './ie-only-message.props.autogenerated';

/**
 *
 * IeOnlyMessage component
 * @extends {React.PureComponent<IIeOnlyMessageProps<{}>>}
 */
class IeOnlyMessage extends React.PureComponent<IIeOnlyMessageProps<{}>> {

    public render(): JSX.Element | null {
        // tslint:disable-next-line: prefer-const no-var-keyword
        var text = this.props.config.text;
        if (text && this._isIE()) {
            this._overrideBody();
        }

        if (text && this.props.config.detectChromeIOS && this._isChromeIOS()) {
            this._overrideBody();
        }
        return null;
    }

    private _overrideBody(): void {
        this._injectStyle();
        document.body = document.createElement('body');
        // tslint:disable-next-line: restrict-plus-operands no-inner-html
        document.body.innerHTML = `<div class="browser-detector">${this.props.config.text as string}</div>`;
    }

    private _injectStyle(): void {
        // tslint:disable-next-line: prefer-const no-var-keyword
        var $style = document.createElement('style');
        // tslint:disable-next-line: restrict-plus-operands no-inner-html
        $style.innerHTML = '.browser-detector { padding: 3rem 1.5rem; text-align: center; }';
        document.head.appendChild($style);
    }

    private _isChromeIOS(): boolean {

        // tslint:disable-next-line: no-typeof-undefined
        if (typeof navigator === 'undefined') {
            return false;
        }

        // DETECTION FUNCTION SOURCE:
        // https://stackoverflow.com/a/37178303

        // detects if user is using Chrome on Apple IOS
        if (/CriOS/i.test(navigator.userAgent) &&
            /iphone|ipod|ipad/i.test(navigator.userAgent)) {
            return true;
        } else {
            return false;
        }
    }

    private _isIE(): boolean {
        // DETECTION FUNCTION SOURCE:
        // https://www.w3docs.com/snippets/javascript/how-to-detect-internet-explorer-in-javascript.html

        // detects if user is using Internet Explorer
        // returns version of IE or false, if browser is not IE
        // Function to detect IE or not
        // tslint:disable-next-line: typedef function-name
        function IEdetection() {
            // tslint:disable-next-line: no-typeof-undefined
            if (typeof navigator !== 'undefined') {

                // tslint:disable-next-line: no-var-keyword prefer-const
                var ua = navigator.userAgent;
                // tslint:disable-next-line: no-var-keyword prefer-const
                var msie = ua.indexOf('MSIE ');
                if (msie > 0) {
                    // IE 10 or older, return version number
                    // tslint:disable-next-line: prefer-template restrict-plus-operands
                    return (`IE ${  parseInt(ua.substring(
                        // tslint:disable-next-line: align
                        msie + 5, ua.indexOf('.', msie)), 10)}`);
                }

                // tslint:disable-next-line: no-var-keyword prefer-const
                var trident = ua.indexOf('Trident/');
                if (trident > 0) {
                    // IE 11, return version number
                    // tslint:disable-next-line: prefer-const no-var-keyword
                    var rv = ua.indexOf('rv:');
                    // tslint:disable-next-line: prefer-template restrict-plus-operands
                    return (`IE ${  parseInt(ua.substring(
                        // tslint:disable-next-line: align
                        rv + 3, ua.indexOf('.', rv)), 10)}`);
                }
            }

            // User uses other browser
            return ('Not IE');
        }

        return IEdetection() !== 'Not IE';
    }
}

export default IeOnlyMessage;
